import { AdminIntroductions } from '@platform/client';
import { useParams } from 'wouter';
import { AdminDetailPage } from '../../AdminDetailPage';
import { DetailsTabContent } from './DetailsTabContent';
import { ProjectPlanTabContent } from './ProjectPlanTabContent';
import { UpdatesTabContent } from './UpdatesTabContent';
import { IntroEmailTabContent } from './EmailTabContent';

export const IntroductionDetail = () => {
  const { introductionId } = useParams<{ introductionId: string }>();
  const {
    data: introData,
    isLoading,
    isSuccess,
  } = AdminIntroductions.useGetIntroductionById(parseInt(introductionId));

  return (
    <>
      <AdminDetailPage
        title={
          introData?.introduction?.id ?
            `Introduction #${introData.introduction.id}`
          : 'Introduction Details'
        }
        isLoading={isLoading}
        isSuccess={isSuccess}
        tabs={[
          {
            id: 'Details',
            content: <DetailsTabContent introData={introData?.introduction} />,
          },
          {
            id: 'Updates',
            content: (
              <UpdatesTabContent
                discoveryUpdates={introData?.discoveryUpdates}
                planUpdates={introData?.planUpdates}
                actionUpdates={introData?.actionUpdates}
              />
            ),
          },
          {
            id: 'Project Work',
            content: (
              <ProjectPlanTabContent
                planData={introData?.projectPlan}
                actionUpdates={introData?.actionUpdates}
              />
            ),
          },
          {
            id: 'Emails',
            content: <IntroEmailTabContent introId={parseInt(introductionId)} />,
          },
        ]}
        pageActions={[
          {
            text: 'Edit',
            href: `/${introductionId}/edit`,
            type: 'link',
          },
        ]}
      />
    </>
  );
};
